<app-header navScreen="Home" class="mb-5"></app-header>
<div class="mx-3 mt-5 pt-4">
  <div class="row ka-search-Header">
    <div class="col d-flex align-items-center">
      Employee List Search
    </div>
    
    <div class="col d-flex justify-content-end pr-0">
      <button mdbBtn class="ka-myProfile-viewType"
      mdbWavesEffect (click)="openEmployeeForm('add')"><i class="fas fa-plus"></i> Create Employee</button>
    </div>
  </div>
  <!-- <div class="col d-flex justify-content-end pr-0">
    <button mdbBtn class="ka-white-button mr-0 tButton ka-btn-primary btn-success btn ka-normalButton-height"
    mdbWavesEffect (click)="openEmployeeForm('add')">Create Employee</button>
  </div> -->
  
  <div class="border p-2 ka-searchEmp-main">
  <form [formGroup]="employeeSearchForm" class="px-2" (submit)="getEmployees($event)">
    <div class="row">
      <div class="col customMultiSelect">
        <label class="text-left ka-createEmp-label ka-float-left" for="region">
          Region </label>
        <ng-multiselect-dropdown [placeholder]="'Any'" [(ngModel)]="selectedRegion"
          [settings]="multiSelectRegionDropdown" [data]="regionArray" formControlName="regionName"
          (onSelect)="getSelectedRegion($event)" (onDeSelect)="onRegionDeSelect($event)"
          (onSelectAll)="onRegionSelectAll($event)" (onDeSelectAll)="onRegionDeSelectAll($event)">
        </ng-multiselect-dropdown>
      </div>
      <div class="col customMultiSelect">
        <label class="text-left ka-float-left ka-createEmp-label" for="branch">
          Branch </label>
        <ng-multiselect-dropdown [placeholder]="'Any'" [(ngModel)]="selectedBranch" [settings]="multiDropdownSettings"
          [data]="branchMultiSelectItems" formControlName="branchName" (onSelect)="onBranchItemSelect($event)"
          (onDeSelect)="onBranchItemDeSelect($event)" (onSelectAll)="onBrachItemsSelectAll($event)"
          (onDeSelectAll)="onBranchDeSelectAll($event)">
        </ng-multiselect-dropdown>
      </div>
      <div class="col flexRows">
        <div class="inputBox customMultiSelect">
          <label class="text-left ka-createEmp-label" for="">Employee Status<span>*</span> </label>
          <select id="name" formControlName="employeeStatus" class="form-select ka-dropdown-singleSelect"
            aria-label="Default select example" style="padding: 0.65rem 0.75rem !important;">
            <option value="">Select </option>
            <option class="select-option" *ngFor="let status of employeeStatusArray" [ngValue]="status">{{status.value}}
            </option>
          </select>
        </div>
      </div>
      <div class="col flexRows">
        <div class="inputBox customMultiSelect">
          <label class="text-left ka-createEmp-label" for="">Employee Type<span>*</span> </label>
          <select id="name" formControlName="employeeType" class="form-select ka-dropdown-singleSelect"
            aria-label="Default select example" style="padding: 0.65rem 0.75rem !important;">
            <option value="">Select </option>
            <option class="select-option" *ngFor="let type of employeeTypeArray" [ngValue]="type">{{type.value}}
            </option>
          </select>
        </div>
      </div>
      <div class="col p-0 flexRows d-flex align-items-center justify-content-center">
        <div class="inputBox customMultiSelect">
          <input type="checkbox" class="mx-2" name="" id="check" formControlName="loginAnywhere">
          <label class="text-left ka-createEmp-label" for="check">Login Anywhere<span>*</span> </label>
        </div>
      </div>
      <div class="col d-flex align-items-center justify-content-center">
        <button mdbBtn class="ka-white-button tButton ka-btn-primary btn-success btn ka-normalButton-height"
          mdbWavesEffect type="submit">Search</button>
      </div>
    </div>
  </form>
  
  <div *ngIf="employeeArray.length>0" class="mt-2 border rounded">
    <div class="dialog-window">
      <div class="row d-flex flex-wrap scrollable-content">
        <div class="card m-1" style="height: 410px;width: 240px;" *ngFor="let employee of employeeArray">
          <div style="position: relative; width: 100%; padding-top: 100%;">
            
              <img src="{{employee.imgPath}}"
                class="" style="position:  absolute;top: 0;left: 0;bottom: 0; right: 0; height:100%;width:100%; object-fit:cover"/>
            
          </div>
          <div class="" style="margin: 0px 10px;">
            <div class="card-title" style="color:blue; font-weight:700;margin-top: 5px;">{{employee.firstName}} {{employee.lastName}} ({{employee.loginName}})</div>
            <p class="card-text ka-searchEmp-content"> {{ employee.officialEmailID}} </p>
            <p class="card-text ka-searchEmp-content"> {{ employee.officialCellPhone}} </p>
            <p class="ka-searchEmp-content">{{employee.loginfrom.replace('1/1/1900 ','')}} to {{employee.loginto.replace('1/1/1900 ','')}}</p>
            <div class="ka-searchEmp-content">Login Anywhere : <span *ngIf="employee.isLoginAnywhere">Yes</span><span
                *ngIf="!employee.isLoginAnywhere">No</span></div>
                <div class="ka-searchEmp-actions">
                  <a class="mx-1" (click)="openEmployeeForm('edit',employee)">Edit</a>
                  <a class="mx-1" (click)="activateEmployee(employee)">Active</a>
                  <a class="mx-1" (click)="deleteEmployee(employee)">Delete</a>
                  <a class="mx-1"(click)="disableEmployee(employee)">Disable</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>




<div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="alert-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
                <span aria-hidden="true" class="alertClose" >&times;</span>
            </button>
            <div class="row text-left">

                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            <p class="mt-2 p-0">{{responseMessage}} </p>

                            <div class="action-buttons">
                                <button mdbBtn class="ka-myProfile-viewType"
                                    mdbWavesEffect type="submit" (click)="successModal.hide()">ok
                                </button>



                            </div>

                        </div>
                    </div>

                </div>

                <!--Grid column-->



            </div>
        </div>
    </div>
</div>